'use strict';

function copyContextData(contexts, target) {
  contexts.forEach(function forEachContext(context) {
    Object.keys(context).forEach(function forEachContextProp(prop) {
      target[prop] = context[prop];
    });
  });
}

function mergeContexts(/* ...contextsOrPOJO */) {
  var ret = {};
  var contextsOrPOJO;
  var i;

  var argslen = arguments.length;
  for (i = 0; i < argslen; ++i) {
    contextsOrPOJO = arguments[i];

    if (typeof contextsOrPOJO !== 'object' || contextsOrPOJO === null) continue;
    if (!Array.isArray(contextsOrPOJO)) contextsOrPOJO = [contextsOrPOJO];
    copyContextData(contextsOrPOJO, ret);
  }

  return ret;
}

function defaultSerializer(context, prop, value) {
  context[prop] = value;
}

function NodeContext() {
  this.context = this.context || {};
}

NodeContext.prototype.setContext = function setContext(propOrObject, value, serializer) {
  var context = this.context;
  var object = {};

  if (!serializer) serializer = defaultSerializer; // eslint-disable-line no-param-reassign

  if (typeof propOrObject !== 'object') {
    object[propOrObject] = value;
  } else if (propOrObject !== null) {
    object = propOrObject;
  }

  Object.keys(object).forEach(function forEachContextProp(prop) {
    serializer(context, prop, object[prop]);
  });
};

NodeContext.prototype.getContext = function getContext(prop) {
  var context = this.context;
  var value;

  if (prop === undefined) {
    return this.getFullNodeContext(true);
  }

  if (context.hasOwnProperty(prop)) {
    value = context[prop];
  } else {
    if (this.parent) {
      value = this.parent.getContext(prop);
    } else if (this !== this.root) {
      value = this.root.getContext(prop);
    }
  }

  return value;
};

NodeContext.prototype.deleteContext = function deleteContext(prop) {
  var context = this.context;

  if (context.hasOwnProperty(prop)) {
    delete context[prop];
  }
};

NodeContext.prototype.getFullNodeContext = function getFullNodeContext(includeRoot) {
  var contexts = [];
  var currentNode = this;

  while (currentNode) {
    if (currentNode !== currentNode.root) contexts.push(currentNode.context);
    currentNode = currentNode.parent;
  }

  // Include root by default if we are the root
  if (includeRoot === true || includeRoot === undefined && this === this.root) {
    contexts.push(this.root.context);
  }

  return mergeContexts.apply(null, contexts.reverse());
};

module.exports = {
  pluginName: 'context',

  dependencies: ['parent'],

  nodeInit: NodeContext,
  nodeMethods: NodeContext.prototype,

  // Static plugin methods
  mergeContexts: mergeContexts
};



//////////////////
// WEBPACK FOOTER
// ./~/@getgo/arborist/plugins/context.js
// module id = 716
// module chunks = 0